// extracted by mini-css-extract-plugin
export var displayNone = "_ph-6";
export var imgContainer = "_ph-2";
export var overflowHidden = "_ph-3";
export var productInfoCardButtonContainer = "_ph-5";
export var productTitleText = "_ph-4";
export var rightArrow = "_ph-1";
export var rightArrowContainer = "_ph-0";